import * as Yup from "yup";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { Dialog } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import BCHeader from "../../shared/BCHeader";

import { ButtonPrimary, HStack } from "../../components/utils";

import UserProfileForm from "./UserProfileForm";
import { UserProfile } from "../../types/UserDetailModel";
import {
  useGetUserProfile,
  useSaveUserProfile,
} from "../../queries/userProfile";
import { ChangePassword } from "../../modals/ChangePassword";

function UserProfilePage() {
  const { data: userProfileDetails } = useGetUserProfile();

  const { mutate: saveUserDetails } = useSaveUserProfile();

  const navigate = useNavigate();

  const [dialog, setDialog] = useState<{
    open: boolean;
    message?: string;
  }>({
    open: false,
  });

  const initialValues = {
    fullName: userProfileDetails?.fullName || "",
    emailAddress: userProfileDetails?.emailAddress || "",
    phoneNumber: userProfileDetails?.phoneNumber || "",
    pan: userProfileDetails?.pan || null,
    countryOfResidence: userProfileDetails?.countryOfResidence || "India",
    nationality: userProfileDetails?.nationality || "India",
    companyName: userProfileDetails?.companyName || "",
    designation: userProfileDetails?.designation || "",
    linkedInProfile: userProfileDetails?.linkedInProfile || null,
    gender: userProfileDetails?.gender || null,
  };

  const handleUserProfileSubmit = (values: UserProfile) => {
    saveUserDetails(values, {
      onSuccess: () => {
        toast("User Profile updated Successfully!", {
          type: "success",
          autoClose: 2000,
        });
        navigate("/options/esopOverview");
      },
      onError: (err: any) => {
        toast(err.response.data.errorMessage, {
          type: "error",
          autoClose: 2000,
        });
      },
    });
  };
  const validationUserDetailsSchema = Yup.object().shape({
    fullName: Yup.string().required().label("User Name"),
    emailAddress: Yup.string().email().required().label("Email ID"),
    phoneNumber: Yup.string().required().label("Contact Number"),
    pan: Yup.string().nullable(true).label("PAN"),
    countryOfResidence: Yup.string().required().label("Country Of Residence"),
    nationality: Yup.string().required().label("Nationality"),
    companyName: Yup.string().nullable(true).label("Company Name"),
    designation: Yup.string().nullable(true).label("Designation"),
    linkedInProfile: Yup.string().nullable(true).label("LinkedIn"),
    gender: Yup.string().nullable(true).label("Gender"),
  });

  return (
    <div className="gap-4 mx-auto">
      <BCHeader
        className="items-baseline mb-4"
        bcTitle="User Profile"
        bcSubTitle=""
      />
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={(values: UserProfile, error: any) => {
          handleUserProfileSubmit(values);
        }}
        validationSchema={validationUserDetailsSchema}
      >
        {(formik) => (
          <>
            <Form>
              <Dialog open={dialog.open} maxWidth="md">
                <ChangePassword
                  onSecondaryAction={() => setDialog({ open: false })}
                />
              </Dialog>
              <UserProfileForm setDialog={setDialog} />
              <HStack className="justify-end mt-3">
                <ButtonPrimary type="submit">Save</ButtonPrimary>
              </HStack>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}

export default UserProfilePage;
